enum TrailType {
  GOLF = 'golf',
  // HUNT = 'hunt',
  // SPORT = 'sport',
  STANDARD = 'standard',
}

export default TrailType